import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import LinkHandler from "./LinkHandler";

const initialState = {
  name: "",
  email: "",
  message: "",
  address: "",
  type: "Шлифовка",
  m2: "",
  launch: "",
  budget: "",
  telephone: "",
};

export const Contacts = (props) => {
  const [, setState] = useState(initialState);
  const [submitStatus, setStatus] = useState("idle"); // button idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    const optionalFields = ["m2", "launch", "budget", "email"];
    optionalFields.forEach((field) => {
      const value = formData.get(field);
      if (!value || value.trim() === "") {
        formData.set(field, "Не указано");
      }
    });

    setStatus("sending");

    emailjs
      .send("service_4i2r9vw", "template_dn1qpy9", Object.fromEntries(formData), "8kLX3d1A4x4V1SKvY")
      .then(
        (result) => {
          console.log("SUCCESS:", result.text);
          setStatus("success");
          clearState();
          form.reset();

          setTimeout(() => {
            setStatus("idle");
          }, 2000);
        },
        (error) => {
          console.log("ERROR:", error.text);
          setStatus("error");

          setTimeout(() => {
            setStatus("idle");
          }, 2000);
        }
      );
  };

  return (
    <div>
      <div className="contacts text-center">
        <div className="container">
          <div className="col-md-3 col-md-offset-1 contacts-info">
            <div className="row">
              <div className="section-title">
                <h2>Контактная информация</h2>
                <p>Напишите или позвоните нам для консультации!</p>
                <p>Мы всегда рады ответить на ваши вопросы, уточнить детали заказа и помочь с выбором подходящего решения.</p>
                <p>Вы можете связаться с нами любым удобным способом или заполнить форму ниже – мы ответим в кратчайшие сроки.</p>
                <div className="contacts-section">
                  <div className="contacts-section-left">
                    <div className="contacts-item telephone">
                      <p>
                        <span>
                          <a href="tel:+79216546574" className="link" title="Позвонить (доступно только для мобильных устройств)">
                            <i className="fa fa-phone"></i>
                            {props.data ? props.data.phone : "Загрузка..."}
                          </a>
                        </span>
                      </p>
                    </div>
                    <div className="contacts-item">
                      <p>
                        <span>
                          <a href={props.data ? "mailto:" + props.data.email : "Загрузка..."} className="link" title="Написать на почту">
                            <i className="fa fa-envelope-o"></i>
                            {props.data ? props.data.email : "Загрузка..."}
                          </a>
                        </span>
                      </p>
                    </div>
                    <div className="contacts-item">
                      <p>
                        <span>
                          <LinkHandler href={props.data ? "https://yandex.ru/maps/?text=" + props.data.address : "Загрузка..."} title="Найти на Yandex картах">
                            <i className="fa fa-map-marker"></i>
                            {props.data ? props.data.address : "Загрузка..."}
                          </LinkHandler>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="contacts-section-right">
                    <div className="contacts-item">
                      <p>
                        <span>
                          <LinkHandler href={props.data ? props.data.telegram : "Загрузка..."} title="Написать в Telegram">
                            <i className="fa fa-telegram"></i>
                            Telegram
                          </LinkHandler>
                        </span>
                      </p>
                    </div>
                    <div className="contacts-item">
                      <p>
                        <span>
                          <LinkHandler href={props.data ? props.data.whatsapp : "Загрузка..."} title="Написать в WhatsApp группу">
                            <i className="fa fa-whatsapp"></i>
                            WhatsApp
                          </LinkHandler>
                        </span>
                      </p>
                    </div>
                    <div className="contacts-item">
                      <p>
                        <span>
                          <LinkHandler href={props.data ? props.data.avito : "Загрузка..."} title="Посмотреть объявление на Avito">
                            <i className="fa fa-share-square-o"></i>
                            Avito
                          </LinkHandler>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h3>Часто задаваемые вопросы (ЧаВо)</h3>
              <p><strong>Сколько времени занимает обработка моего запроса?</strong></p>
              <p>Обычно мы отвечаем в течение 1 рабочего дня.</p>
              <p><strong>Как узнать стоимость работ?</strong></p>
              <p>Укажите основные параметры вашего проекта в форме, и мы свяжемся с вами с предварительным расчётом.</p>
            </div>
          </div>

          <div className="col-md-8">
            <div className="row">
              <h3>Форма обратной связи</h3>
              <p>Укажите детали вашего проекта, чтобы мы могли предложить вам лучшее решение. Мы обязательно свяжемся с вами для уточнения деталей и предоставления консультации.</p>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="form-group">
                  <p className="required">Опишите задачу в нескольких предложениях</p>
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Нам необходимо..."
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div className="row">

                  <div className="col-md-6">
                    <div className="form-group">
                      <p className="required">Адрес расположения объекта</p>
                      <input
                        type="text"
                        id="address"
                        name="address"
                        className="form-control"
                        placeholder="г. Санкт-Петербург, ул. Почтамтская д. 9"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p className="required">Укажите тип задачи</p>
                      <select
                        id="type"
                        name="type"
                        aria-label="type"
                        className="form-control"
                        required
                        onChange={handleChange}
                      >
                        <option value="Шлифовка">Шлифовка</option>
                        <option value="Полировка">Полировка</option>
                        <option value="Другое">Другое</option>
                      </select>
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p>Примерная площадь работ (м²)</p>
                      <input
                        type="text"
                        id="m2"
                        name="m2"
                        className="form-control"
                        placeholder="5 м²"
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p>Предполагаемые сроки начала работ</p>
                      <input
                        type="text"
                        id="launch"
                        name="launch"
                        className="form-control"
                        placeholder="1 неделя"
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p>Ожидаемый бюджет (в руб.)</p>
                      <input
                        type="text"
                        id="budget"
                        name="budget"
                        className="form-control"
                        placeholder="50 000 руб."
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p>Ваш E-Mail для связи</p>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="liftblesk@ya.ru"
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p className="required">Ваш контактный номер телефона</p>
                      <input
                        type="text"
                        id="telephone"
                        name="telephone"
                        className="form-control"
                        placeholder="+7 (921) 654-65-74"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <p className="required">Как к Вам обращаться?</p>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Имя"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <p><span style={{ color: "red" }}>*</span> — обязательно для заполнения</p>
                </div>

                <div id="success"></div>
                <button
                  type="submit"
                  className="btn btn-blesk btn-lg"
                  disabled={submitStatus === "sending"}
                >
                  {submitStatus === "idle" && (<>Отправить заказ <i className="fa fa-paper-plane"></i></>)}
                  {submitStatus === "sending" && (<>Отправка заказа... <i className="fa fa-spinner fa-spin"></i></>)}
                  {submitStatus === "success" && (<>Заказ отправлен <i className="fa fa-check"></i></>)}
                  {submitStatus === "error" && (<>Ошибка отправки! <i className="fa fa-exclamation-triangle"></i></>)}
                </button>
              </form>
            </div>
          </div>

          <LinkHandler href="/" title="Пролистать на главную (на самый верх)" className="btn btn-blesk btn-lg page-scroll">
            На главную
          </LinkHandler>
        </div>
      </div>
    </div>
  );
};
